<pgh-modal-window size="md plus">
  <div modal-title class="title-with-icon service-title">
    <div class="icon-container" *ngIf="!emailNotice">
      <mat-icon [svgIcon]="modalData.icon"></mat-icon>
    </div>
    <h4 class="modal-title" *ngIf="!emailNotice">{{modalData.serviceName}}</h4>
    <h4 class="modal-title" *ngIf="emailNotice">{{modalData.redeemedTitle}}</h4>
  </div>
  <div modal-body>
    <p class="content">{{redeemed ? modalData.redeemedContent : modalData.content}}</p>
    <p class="disclaimer"> {{modalData.disclaimer}}</p>
    <mat-divider></mat-divider>
  </div>
  <div modal-footer *ngIf="!emailNotice">
    <div class="options-question" *ngIf="!!modalData?.rightAction[0]"> {{modalData?.redeemQuestion}} </div>
    <div [ngClass]="!!modalData?.rightAction[0] ? 'footer-options' : 'footer-option'">
      <button mat-flat-button color="accent" [disabled]="buttonDisabled"
              *ngIf="modalData.leftAction && modalData.leftAction.length"
              (click)="onAction(modalData.leftAction[0])"
              focused>
        {{modalData?.leftAction[0]?.buttonText}}
      </button>
      <button mat-flat-button color="accent"
              *ngIf="!!modalData?.rightAction[0]"
              [disabled]="buttonDisabled"
              (click)="onAction(modalData.rightAction[0])"
              focused>
        {{modalData?.rightAction[0]?.buttonText}}
      </button>
    </div>
  </div>
  <div modal-footer class="footer-option" *ngIf="emailNotice">
    <button mat-flat-button color="accent" type="button" (click)="closeModal()">
      <adp-label labelKey="Global_Button_Close"></adp-label>
    </button>
  </div>
</pgh-modal-window>
